import {getControlPanelConfig} from 'api/config/config';
import {ConfigResponse} from 'api/config/config.types';

/**
 * @module utils/startup
 */

/**
 * Defines the parameter for setConfigValues function
 */
export interface StartUpConfigValues {
    spotHeroMixpanelToken: string;
    segmentApiKey: string;
    isSegmentEnabled: boolean;
    isWootricEnabled: boolean;
    sentryAPIPublicKey: string;
    forceWootricSurvey: boolean;
    cloudfrontViewerCountryCode: string;
}

/**
 * Loads the Control Panel configuration from the API and then sets the response.
 *
 * @param setConfigValues - The function to set the configuration values
 * @returns A promise that resolves when the configuration has been successfully loaded and set
 */
const loadConfig = async (
    setConfigValues: (configValues: StartUpConfigValues) => void
): Promise<void> => {
    const {
        segmentApiKey,
        isSegmentEnabled,
        isWootricEnabled,
        forceWootricSurvey,
        sentryAPIPublicKey,
        spotHeroMixpanelToken,
        cloudfrontViewerCountryCode,
    }: ConfigResponse = await getControlPanelConfig();

    setConfigValues({
        segmentApiKey,
        isSegmentEnabled,
        isWootricEnabled,
        forceWootricSurvey,
        sentryAPIPublicKey,
        spotHeroMixpanelToken,
        cloudfrontViewerCountryCode,
    });
};

export default loadConfig;
